angular.module("dpw.services").factory("jsonDownloadService", ['$window',
    function ($window) {
        return {
            download: function (fileName, content) {
                if (typeof content !== 'string') {
                    content = JSON.stringify(content, null, 4);
                }

                const element = $window.document.createElement("a");
                element.setAttribute(
                    "href",
                    "data:application/json;charset=utf-8," +
                        encodeURIComponent(content)
                );
                element.setAttribute("download", fileName);
                element.style.display = "none";
                $window.document.body.appendChild(element);
                element.click();
                $window.document.body.removeChild(element);
            },
        };
    },
]);
